import styled from 'styled-components'
import { rem } from 'polished'
import Group from 'components/utils/Group'
import Sheet from 'components/utils/Sheet'
import Clickable from 'components/Common/Clickable'
import TextButton from 'LuxKit/Button/TextButton'

// The border is drawn here rather than through Sheet's `border` prop so surfaces can
// flatten the card into a full-bleed band by zeroing the width.
export const StopSheet = styled(Sheet)`
  width: 100%;
  border: var(--trip-plan-canvas-section-border-width, 1px) solid ${props => props.theme.palette.neutral.surface.lightForeground};
  border-radius: var(--trip-plan-canvas-section-radius, ${props => props.theme.borderRadius.L});
  background: ${props => props.theme.palette.neutral.surface.normalBackground};
`

export const StopSheetContent = styled(Group)`
  padding: var(--itinerary-section-padding, ${rem(20)});
`

// Wraps the highlights/itinerary block. Nested inside the stop sheet, so surfaces that
// want a single inset (the mobile timeline) collapse this padding to zero.
export const StopItinerarySheet = styled(Sheet)`
  padding: var(--trip-plan-canvas-nested-padding, ${rem(16)});
`

export const ImageContainer = styled(Clickable)`
  width: var(--itinerary-stop-image-size, ${rem(136)});
  height: var(--itinerary-stop-image-size, ${rem(136)});
  border-radius: ${props => props.theme.borderRadius.M};
  overflow: hidden;
  flex-shrink: 0;
`

export const StopMainContent = styled(Group)`
  min-width: 0;
`

export const StopHeaderChevronButton = styled(Clickable)`
  flex-shrink: 0;
  align-self: center;
  color: ${props => props.theme.palette.neutral.default.two};
`

export const StopHeaderChevron = styled.div<{ $expanded: boolean }>`
  display: inline-flex;
  transform: rotate(${props => (props.$expanded ? '0deg' : '-90deg')});
  transition: transform 200ms ease;
`

export const StopLearnMoreButton = styled(TextButton)`
  align-self: flex-start;
  padding-inline-start: 0;
`

export const StopDetailsPanel = styled.div<{ $expanded: boolean }>`
  overflow: hidden;
  max-height: ${props => (props.$expanded ? rem(4000) : 0)};
  transition: max-height 340ms ease;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`

export const StopDetailsContent = styled.div<{ $expanded: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${rem(20)};
  padding-top: ${rem(20)};
  opacity: ${props => (props.$expanded ? 1 : 0)};
  transform: translateY(${props => (props.$expanded ? '0' : rem(-8))});
  transition:
    opacity 260ms ease,
    transform 320ms ease;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`

export const StopTitleContent = styled(Group)`
  min-width: 0;
`

export const ClickableHeading = styled(Clickable)`
  &:hover {
    text-decoration: underline;
  }
`

export const ClickableHighlightTitle = styled(Clickable)`
  font-weight: bold;

  &:hover {
    text-decoration: underline;
  }
`
